if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.productInfo = document.querySelector('product-info[id^="MainProduct-"]');
        this.sectionId = this.productInfo?.dataset.section;
        this.button = this.querySelector('[data-sticky-button]');
        this.price = this.querySelector('[data-sticky-price]');
      }

      connectedCallback() {
        if (!this.productInfo || !this.sectionId) return;

        this.button.addEventListener('click', this.onButtonClick.bind(this));
        this.setupVisibility();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId === this.sectionId) this.syncWithMainForm();
          });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.variantChangeUnsubscriber?.();
        if (this.onScrollEnd) window.removeEventListener('scrollend', this.onScrollEnd);
      }

      get mainSubmitButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      setupVisibility() {
        const target = this.mainSubmitButton || this.productInfo;
        const showOnDesktop = this.dataset.showOnDesktop === 'true';
        const desktopQuery = window.matchMedia('(min-width: 990px)');

        const update = (rect) => {
          const passed = rect.bottom < 0;
          const allowed = showOnDesktop || !desktopQuery.matches;
          this.classList.toggle('is-visible', passed && allowed);
        };

        this.observer = new IntersectionObserver(([entry]) => update(entry.boundingClientRect), { threshold: 0 });
        this.observer.observe(target);

        // Jumps (e.g. back to top) can skip intersection changes, so re-check once scrolling settles.
        this.onScrollEnd = () => update(target.getBoundingClientRect());
        window.addEventListener('scrollend', this.onScrollEnd, { passive: true });
      }

      onButtonClick() {
        const mainButton = this.mainSubmitButton;
        if (!mainButton || mainButton.disabled) {
          this.productInfo.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        mainButton.click();
      }

      syncWithMainForm() {
        const mainButton = this.mainSubmitButton;
        const mainPrice = document.getElementById(`price-${this.sectionId}`);

        if (mainPrice) this.price.innerHTML = mainPrice.innerHTML;
        if (mainButton) {
          const label = mainButton.querySelector('span');
          this.button.disabled = mainButton.disabled;
          if (label) this.button.textContent = label.textContent.trim();
        }
      }
    }
  );
}
